// extracted by mini-css-extract-plugin
export default {"wrapper":"BookingBlock_wrapper__2b55J","message_box":"BookingBlock_message_box__ZuXOk"};